module.exports = __webpack_public_path__ + "static/media/screen_gallery_plus_25.4b5178e8.svg";